/*
 * @Author: wbhuangcj
 * @Date: 2021-11-09 19:06:32
 * @LastEditors: huangcj
 * @LastEditTime: 2022-03-18 17:24:55
 * @Description: 公用js文件
 */
export default {
	created() {
		console.log("使用混入");

	},
	data(){
		const pageHeight = window.innerHeight-(65+48)+'px';//屏幕高度减去导航栏和内补白
    const tablePager ={
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    }
    const toolbar ={
      loading: false,
      formData: {
        searchKey: ''
      }
    }
		return {
      tableData: null,
      tablePager,
      toolbar,
			pageHeight
		}
	},
	methods: {
		handlePageChange() {
     // this.findData();
    },
	}
}

